module.exports = __webpack_public_path__ + "img/booth_10x10.d5408962.jpg";